import {ValidateState} from 'lib.common';
import {PtrnCampoEditableFloat, PtrnCampoValidarResult} from '../../patronTypes';
import {PtrnTransformarCampoFn, PtrnValidarCampoFn} from './ptrnProcesarTypes';
import {PtrnProcesarUtilsCfg, PtrnProcesarValidacionesComunes} from './ptrnProcesarUtils';

export const ptrnValidarFloat: PtrnValidarCampoFn<any, PtrnCampoEditableFloat> = (
   currValue,
   campoConfig,
   estado
) => {
   const validateResult: PtrnCampoValidarResult = PtrnProcesarUtilsCfg.NoErrResult();

   //Determinata si newValue es string ya que trabaja con dos formatos diferentes
   // string y {numero:number,formato:string} deberia trabajar con la segunda
   //TODO: cambiar a segundo formato

   const esStringNewValue = typeof currValue === 'string';
   if (esStringNewValue) {
      const esNegativo = currValue[0] === '-';
      const restoValor = esNegativo ? currValue.slice(1) : currValue;
   
      // Validar si se permite el símbolo negativo
      if (!campoConfig.permitirNegativos && esNegativo) {
         validateResult.errores.push(
            PtrnProcesarUtilsCfg.ErrValidar(`No se permiten negativos`)
         );
         validateResult.gravedadMaxima = ValidateState.ERROR;
         return validateResult;
      }
   
      // Permitir que el valor comience con un punto (".") o sea un número válido
      const patronNumerico = /^(\d+|\d*\.\d*)$/; // Permite números enteros, decimales y solo "."
   
      if (restoValor && !patronNumerico.test(restoValor)) {
         validateResult.errores.push(
            PtrnProcesarUtilsCfg.ErrValidar(`Solo se permiten valores numéricos`)
         );
         validateResult.gravedadMaxima = ValidateState.ERROR;
         return validateResult;
      }
   }

   //|---> si existe error hacer result.push(<mensaje_error>) y retornar result

   // Validación independiente para dígitos enteros
   if (campoConfig.maxDigitosEnteros != undefined && esStringNewValue) {
      if (
         !PtrnProcesarValidacionesComunes.validadorDigitosEnteros(
            currValue.toString(),
            campoConfig.maxDigitosEnteros
         )
      ) {
         validateResult.errores.push(
            PtrnProcesarUtilsCfg.ErrValidar(
               `El valor no puede tener más de ${campoConfig.maxDigitosEnteros} dígitos en la parte entera`
            )
         );
         validateResult.gravedadMaxima = ValidateState.ERROR;
         return validateResult;
      }
   }

   // Validación independiente para dígitos decimales
   if (campoConfig.maxDigitosDecimales != undefined && esStringNewValue) {
      if (
         !PtrnProcesarValidacionesComunes.validadorDigitosDecimales(
            currValue.toString(),
            campoConfig.maxDigitosDecimales
         )
      ) {
         validateResult.errores.push(
            PtrnProcesarUtilsCfg.ErrValidar(
               `El valor no puede tener más de ${campoConfig.maxDigitosDecimales} dígitos en la parte decimal`
            )
         );
         validateResult.gravedadMaxima = ValidateState.ERROR;
         return validateResult;
      }
   }
   if (esStringNewValue && PtrnProcesarValidacionesComunes.esMayor(currValue, campoConfig.max)) {
      validateResult.errores.push(
         PtrnProcesarUtilsCfg.ErrValidar(`El valor no puede ser mayor a: ${campoConfig.max}`)
      );
      validateResult.gravedadMaxima = ValidateState.ERROR;
      return validateResult;
   }

   if (esStringNewValue && PtrnProcesarValidacionesComunes.esMenor(currValue, campoConfig.min)) {
      validateResult.errores.push(
         PtrnProcesarUtilsCfg.ErrValidar(`El valor no puede ser menor a: ${campoConfig.min}`)
      );
      validateResult.gravedadMaxima = ValidateState.ERROR;
      return validateResult;
   }

   return validateResult;
};

export const ptrnTranformarFloat: PtrnTransformarCampoFn<any, PtrnCampoEditableFloat> = (
   originalValue,
   campoConfig,
   estado
) => {
   let newValue = originalValue;
   //3. modificacion del nuevo valor de acuerdo a la configuracion
   if (typeof newValue === 'string') {
      // Removemos todos los signos negativos
      let numeroLimpio = newValue.replace(/-/g, '');
      // Permitimos dígitos y un único punto decimal
      numeroLimpio = numeroLimpio.replace(/[^.\d]/g, '');

      // Asegurarnos de que solo hay un punto decimal
      const partes = numeroLimpio.split('.');
      if (partes.length > 2) {
         numeroLimpio = `${partes[0]}.${partes.slice(1).join('')}`;
      }
      // Eliminamos ceros a la izquierda de la parte entera, excepto si el número comienza con "0."
      if (numeroLimpio.startsWith('0') && !numeroLimpio.startsWith('0.')) {
         numeroLimpio = Number(numeroLimpio).toString();
      }

      // Si el valor original comenzaba con signo negativo y está permitido, lo preservamos
      if (
         campoConfig.permitirNegativos &&
         newValue.startsWith('-') &&
         !numeroLimpio.startsWith('-')
      ) {
         numeroLimpio = '-' + numeroLimpio;
      }

      // Si el valor se modificó o quedó vacío, actualizamos newValue
      if (numeroLimpio !== newValue || numeroLimpio === '') {
         newValue = numeroLimpio === '' ? '' : numeroLimpio;
      }
   }
   return newValue;
};
